import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import image_croix from "../Pages/image/croix.png";
import TrainingService from '../../Service/TrainingService';

const TrainingPublic = ({ training, conditions }) => {
    const [editMode, setEditMode] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const token = sessionStorage.getItem('token');

    // Convertir le HTML en texte brut au moment de l'édition
    useEffect(() => {
        if (training.prerequis) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = training.prerequis;  // Le texte initial est en HTML
            setTextAreaValue(tempDiv.innerText);  // Convertir le HTML en texte brut pour l'édition
        }
    }, [training.prerequis]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleInputChange = (event) => {
        setTextAreaValue(event.target.value);
    };

    const handleSaveClick = async () => {
        // Sauvegarder le texte modifié dans l'objet training
        training.prerequis = textAreaValue;  // Le texte modifié reste en texte brut

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        setEditMode(false);
    };

    return (
        <div className="section-content">
            {editMode ? (
                <textarea
                    value={textAreaValue}
                    onChange={handleInputChange}
                    rows={10}
                    style={{ width: '100%' }}
                />
            ) : (
                // Diviser le texte en plusieurs lignes et ajouter l'icône pour chaque ligne
                <div>
                    {training.prerequis}
                </div>
            )}
            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
            <section className="handicap-info">
                <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/0bb29d63109b9de5b8cf324eff593f5d685bdbc77f0ce284ac33164628e4c32e?apiKey=59156c16963f46e28d2e0d857e2bfa45&" alt="Handicap accessibility icon" className="handicap-icon" />
                <p
                    className="handicap-text"
                    dangerouslySetInnerHTML={{ __html: training.accessibility }}
                />
            </section>
        </div>
    );
};

export default TrainingPublic;